import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { ArtifactStatus, IKBArtifact, IKBCatalog, IKBCatalogCategory } from '../interfaces/IBase-knowledge-catalog';
import { I18nService } from 'i18n/i18n.service';
import { KBCatalogFactory } from '../factories/kb-catalog.factory';
import { CatalogOperationsService } from '../services/catalog-operations.service';
import { ModalOperationsService } from '../services/modal-operations.service';
import { NotificationService } from '../services/notification.service';
import { StateOperationsService } from '../services/state-operations.service';
import { BkCatalogApiService } from '../services/bk-catalog-api.service';
import { BaseKnowledgeCatalogService } from '../services/base-knowledge-catalog.service';

@Component({
  selector: 'biz-base-knowledge-catalog-static',
  templateUrl: './base-knowledge-catalog-static.component.html',
  styleUrls: ['./base-knowledge-catalog-static.component.scss']
})
export class BaseKnowledgeCatalogStaticComponent implements OnChanges, OnDestroy {

  public allCategory: IKBCatalogCategory = { DisplayName: 'All', Description: 'All', Id: 'All', Expanded: false, EditMode: false, KBCatalogs: [] };
  public categoryList: IKBCatalogCategory[] = [];
  public selectedCategory: IKBCatalogCategory;
  public Processing = ArtifactStatus.Processing;
  public Available = ArtifactStatus.Available;
  public Failed = ArtifactStatus.Failed;
  public ToProcess = ArtifactStatus.ToProcess;
  public Unknown = ArtifactStatus.Unknown;
  public showEditedCategory: boolean = false;

  @Input() filteredCategoryList: IKBCatalogCategory[] = [];
  @Output() reloadCatalogs = new EventEmitter<boolean>();

  constructor(
    private _i18nService: I18nService,
    private _catalogOperationsService: CatalogOperationsService,
    private _modalOperationsService: ModalOperationsService,
    private _notificationService: NotificationService,
    private _stateOperationsService: StateOperationsService,
    private _bkCatalogApiService: BaseKnowledgeCatalogService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  addNewCatalog(category: IKBCatalogCategory, event?: Event) {
    this._stateOperationsService.stopPropagation(event);
    this.openCatalogModal(KBCatalogFactory.createNew(category), category);
  }

  editCatalog(catalog: IKBCatalog, category: IKBCatalogCategory) {
    this.openCatalogModal(catalog, category);
  }

  addArtificat(catalog?: IKBCatalog) {
    this._modalOperationsService.openArtifactModal(catalog).subscribe(result => {
      if (result) {
        // Handle artifact creation logic here
      }
    });
  }

  openCatalogModal(catalog?: IKBCatalog, category?: IKBCatalogCategory): void {
    this._modalOperationsService.openArtifactModal(catalog).subscribe(result => {
      if (result) {
        this.reloadCatalogs.emit(true);
      }
    });
  }

  deleteCatalog(catalog: IKBCatalog) {
    this._modalOperationsService.openDeleteConfirmationModal(catalog).subscribe((result) => {
      if (result === 'delete') {
        this.deleteCatalogService(catalog);
      }
    });
  }

  deleteCatalogService(catalog: IKBCatalog) {
    this._catalogOperationsService.deleteCatalog(catalog).subscribe({
      next: (response) => {
        this.reloadCatalogs.emit(true);
        this._notificationService.showSuccess(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'));
      }
    });
  }

  toggleCategory(category: IKBCatalogCategory): void {
    this._stateOperationsService.toggleCategory(category);
  }

  toggleCatalog(catalog: IKBCatalog): void {
    this._stateOperationsService.toggleCatalog(catalog);
  }

  onToggleSelectAll(status: string, event?: Event) {
    this._stateOperationsService.handleToggleSelectAll(status, event);
  }

  retryArtifactVectorization(artifact: any, event?: Event): void {
    if (event) { event.stopPropagation(); }
    if (!artifact?.Id) { return; }
    if (artifact.Retrying) { return; }
    artifact.Retrying = true;
    this._bkCatalogApiService.retryKbArtifactVectorization(artifact.Id).subscribe({
      next: () => {
        this._notificationService.showSuccess(this._i18nService.instant('BASEKNOWLEDGECATALOG.RETRY_STARTED'));
        artifact.Retrying = false;
      },
      error: () => {
        this._notificationService.showError(this._i18nService.instant('BASEKNOWLEDGECATALOG.RETRY_FAILED'));
        artifact.Retrying = false;
      }
    });
  }

  getSortedCatalogs(category: any): any[] {
    return category.KBCatalogs ? [...category.KBCatalogs].sort((a: any, b: any) => 
      a.DisplayName.localeCompare(b.DisplayName)
    ) : [];
  }

  get isDevelopment(): boolean {
    const environmentType = sessionStorage.getItem('environmentType');
    return environmentType?.toLowerCase() === 'development';
  }
}
